import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useProductReadContext } from '@context/ProductContext'
import { useSupportContacts } from '@context/SupportContactsContext'

import { PageSection } from '@ui/components/PageSection'

import { FormSubmitValues } from '@utils/formValidation'

import { AccountDetailedDto } from '@model/AccountDetailedDto'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { Loading } from '@shared/components/Loading/Loading'

import { DocumentsPending, isDocumentPendingVisible } from '../DocumentManagement/DocumentsPending'
import { PersonalInfoFormPage, PersonalInfoFormValues } from './PersonalInfoPageForm'
import { useEconomicProfileAnswers, usePersonalInfo } from './hooks/usePersonalInfoHooks'

import styles from './PersonalInfo.module.scss'

export interface PersonalInfoPageProps {
  accountPassed?: AccountDetailedDto
}

export const PersonalInfoPage: FC<PersonalInfoPageProps> = ({ accountPassed }) => {
  useScrollToTop()
  const { product } = useProductReadContext()
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const { appTestAnswers } = usePersonalInfo()
  const { economicProfileAnswers } = useEconomicProfileAnswers()
  const { supportEmail, supportPhoneNumber } = useSupportContacts()

  const handleSubmit = async (values: FormSubmitValues<PersonalInfoFormValues>) => {
    alert(JSON.stringify(values))
  }

  return (
    <Loading isLoading={appTestAnswers.isLoading} showLoadingIcon>
      <PageSection title={t('Profile.Personal Details')} />
      <div className={styles.info}>
        {isDocumentPendingVisible(product, account) && <DocumentsPending />}
        <PersonalInfoFormPage
          appTestAnswers={appTestAnswers.data}
          economicProfileAnswers={economicProfileAnswers.data}
          supportContacts={{ supportEmail, supportPhoneNumber }}
          account={accountPassed || account}
          onSubmit={handleSubmit}
        />
      </div>
    </Loading>
  )
}
